import { FormControl, FormGroup } from '@angular/forms';
import { IColorTypes, ColorStep, IColorSteps, ColorType } from 'libs/shared/src/models';
import { DEFAULT_CONFIG } from '../default.config';

const FALLBACK_COLOR = {
  shine: '#000000',
  main: '#000000',
  shade: '#000000',
  contrast: '#ffffff'
};

export const CONFIG_COLORS_FORM: FormGroup = new FormGroup({
  primary: generateColorGroup(DEFAULT_CONFIG?.colors?.primary ?? FALLBACK_COLOR, 'primary'),
  secondary: generateColorGroup(DEFAULT_CONFIG?.colors?.secondary ?? FALLBACK_COLOR, 'secondary'),
  tertiary: generateColorGroup(DEFAULT_CONFIG?.colors?.tertiary ?? FALLBACK_COLOR, 'tertiary'),
  light: generateColorGroup(DEFAULT_CONFIG?.colors?.light ?? FALLBACK_COLOR, 'light'),
  medium: generateColorGroup(DEFAULT_CONFIG?.colors?.medium ?? FALLBACK_COLOR, 'medium'),
  dark: generateColorGroup(DEFAULT_CONFIG?.colors?.dark ?? FALLBACK_COLOR, 'dark'),
  success: generateColorGroup(DEFAULT_CONFIG?.colors?.success ?? FALLBACK_COLOR, 'success'),
  warning: generateColorGroup(DEFAULT_CONFIG?.colors?.warning ?? FALLBACK_COLOR, 'warning'),
  danger: generateColorGroup(DEFAULT_CONFIG?.colors?.danger ?? FALLBACK_COLOR, 'danger')
});

/**
 * Generate a form group for a color group
 * @param colors The colors to generate the form group for
 * @param name The name of the color group
 * @returns The generated form group
 */
function generateColorGroup(colors: IColorSteps, name: keyof IColorTypes): FormGroup {
  const group = new FormGroup({});
  Object.keys(colors).forEach((key) => {
    const color = DEFAULT_CONFIG?.colors ? DEFAULT_CONFIG?.colors[name as ColorType] : FALLBACK_COLOR;
    const colorStep = color[key as ColorStep];
    group.addControl(key, new FormControl(colorStep));
  });
  return group;
}
